import React from 'react';
import Avatar from '../../../avatar';
import Dropdown from '../../../dropdown';
import Space from '../../../space';
import { MainFrameContext } from '../../index';
const User = (props) => {
    const { name, avatar, menu, onClick } = props;
    const { prefixCls } = React.useContext(MainFrameContext);
    const renderAvatar = () => {
        if (avatar) {
            return React.createElement(Avatar, { src: avatar, size: "small" });
        }
        return (React.createElement(Avatar, { size: "small", className: `${prefixCls}-user-avatar-name` }, name === null || name === void 0 ? void 0 : name.charAt(name.length - 1)));
    };
    const renderContent = () => {
        const dom = (React.createElement(Space, { onClick: onClick },
            renderAvatar(),
            React.createElement("span", { className: `${prefixCls}-user-name` }, name)));
        if (React.isValidElement(menu)) {
            return React.createElement(Dropdown, { overlay: menu }, dom);
        }
        return dom;
    };
    return React.createElement("div", { className: `${prefixCls}-user` }, renderContent());
};
export default User;
